import { render, staticRenderFns } from "./v-card-bg.vue?vue&type=template&id=038aeb68&scoped=true"
var script = {}
import style0 from "./v-card-bg.vue?vue&type=style&index=0&id=038aeb68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038aeb68",
  null
  
)

export default component.exports